export default "__VITE_ASSET__DtFEajkq__"